import './ErrorBoundary.css';

export default function ErrorBoundaryFallback({
  title = 'Algo deu errado',
  message = 'Essa parte do app encontrou um erro inesperado.',
  onReset,
  compact = false,
}) {
  return (
    <div
      className={`error-boundary${compact ? ' error-boundary--compact' : ''}`}
      role="alert"
    >
      <p className="error-boundary__title">{title}</p>
      <p className="error-boundary__message">{message}</p>
      <div className="error-boundary__actions">
        {onReset ? (
          <button type="button" className="error-boundary__btn" onClick={onReset}>
            Tentar de novo
          </button>
        ) : null}
        <button
          type="button"
          className="error-boundary__btn error-boundary__btn--secondary"
          onClick={() => window.location.reload()}
        >
          Recarregar
        </button>
      </div>
    </div>
  );
}
